import classNames from 'classnames'
import React from 'react'

import * as customizationSelectors from 'customizer/customization/selectors'
import { useSelector } from 'customizer/hooks'
import useThemeSettings from 'customizer/theme/useThemeSettings'

import ShareControlFactory from './../controls/ShareControlFactory'

import './SummaryDrawerHeader.scss'

export type SummaryDrawerHeaderProps = React.HTMLAttributes<HTMLDivElement>

const SummaryDrawerHeader = ({ className, ...rest }: SummaryDrawerHeaderProps) => {
  const { titleFontSize, titleColor } = useThemeSettings('summaryDrawer')

  const title = useSelector(customizationSelectors.customizerTitleSelector)

  return (
    <div className={classNames('summary-drawer__header', className)} {...rest}>
      <div className="summary-drawer__header-title" style={{ fontSize: titleFontSize, color: titleColor }}>
        {title}
      </div>

      <ShareControlFactory />
    </div>
  )
}

export default SummaryDrawerHeader
